import React from "react";
import "./otherbsd.scss";
import Produk1 from "./Produk1/produkbsd.jsx";
import Produk2 from "./Produk2/produkbsd1.jsx";

const rumah = () => {
  return (
    <div className="rumah">
      <div>
        <div className="Judul"></div>
        <div className="rumah-card">
          <Produk1 />
          <Produk2 />
        </div>
      </div>
    </div>
  );
};

export default rumah;
